import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-card-circular-chart',
  imports: [Skeleton, CommonModule],
  templateUrl: './card-circular-chart.component.html',
  styleUrl: './card-circular-chart.component.css',
  standalone: true,
})
export class CardCircularChartComponent {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input() tooltip1: string = '';
  @Input() tooltip2: string = '';
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) value!: string;
  @Input({ required: true }) borderBottomColor!: string;
  @Input({ required: true }) chartValue!: number;
  @Input({ required: true }) chartProgressColor!: string;

  get strokeDashOffset(): string {
    const perimeter = 251.2;
    const offset = perimeter - (perimeter * this.chartValue) / 100;

    return `${offset}`;
  }
}
